

<template >
   <div style="margin-top: 40px;">
    <el-col>
      <el-card shadow="always" > 
       智能仓储管理系统
      </el-card>
    </el-col>
    <!-- <el-col>
      <el-carousel :interval="4000" type="card" >
            <el-carousel-item >
            <h3 text="2xl" justify="center" > 
              <a href="https://www.dengsanpeng.com/">
              <img class="picture" src="../assets/pictures/123.jpg" alt="" style=" max-width: 100%;height: auto;" />
            </a> 
            </h3>
          </el-carousel-item>
          <el-carousel-item >
            <h3 text="2xl" justify="center" > 
              <a href="http://www.bonus-robot.com/">
              <img class="picture" src="../assets/pictures/123.jpg" alt="" style=" max-width: 100%;height: auto;" />
            </a> 
            </h3>
          </el-carousel-item>
          <el-carousel-item >
            <h3 text="2xl" justify="center" > 
              <img class="picture" src="../assets/pictures/xuanchuan.png" alt="" style=" max-width: 100%;align-items: center" />
            </h3>
          </el-carousel-item>
          </el-carousel> 
    </el-col> -->
    <el-col>
      <el-card shadow="always"> 
        <el-row>
          <el-col :span="12">
            <el-statistic title="系统访问量" :value="SysCount"  />
          </el-col>
     
          <el-col :span="12">
            <el-statistic title="现有库存统计" :value="StrogeCount" />
          </el-col>
        </el-row>
      </el-card>
    </el-col>

    <!-- <el-col>
      <el-card shadow="always">
        <el-descriptions title="" :column="3" border>
          <el-descriptions-item label="姓名" label-align="right" align="center" label-class-name="my-label" class-name="my-content" width="150px">{{ UserName }}</el-descriptions-item>
          <el-descriptions-item label="电话" label-align="right" align="center">{{ Phone }}</el-descriptions-item>
          <el-descriptions-item label="地区" label-align="right" align="center">{{ Address }}</el-descriptions-item>

          <el-descriptions-item label="Remarks" label-align="right" align="center">
      <el-tag size="small">{{ UserType }}</el-tag>
    </el-descriptions-item>
          <el-descriptions-item label="部门" label-align="right" align="center">{{ DeptName }}</el-descriptions-item>
        </el-descriptions>
    </el-card>
    </el-col> -->





    <el-col>
      <el-card shadow="always"> 
        <div class="echart01">
        <div ref="chart" style="width: 100%; height: 400%">
          
        </div>
      </div>
      </el-card>
    </el-col>

    <el-col>
      <el-card shadow="always"> 
        <template>
          <el-calendar  />
        </template> 
      </el-card>
    </el-col>


</div>
</template>



<script>

import * as echarts from 'echarts'


      
  export default 
  {
    data () 
    {
        return {
            getTypeList: {
           
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'main_variable_maintenance'      
            },
  
            SysCount:0,
            StrogeCount:0,
            UserName:'',
            Phone:'',
            Address:'',
            DeptName:'',
            UserType:'',
            // 查询所需
            ID: ''
        }
    },
    created () {
       this.getNumber()
      
      // 首次打开项目需要调用
      // this.firstLoad()
    },
    mounted () {
    },
    beforeDestroy () {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
      firstLoad() {
        try {
          this.$http.post("/WMS/conn_mqtt")
        } catch (error) {
          
        }
      },
        init (number) {
            const myChart = echarts.init(this.$refs.chart)
          
            const option = {
              title:{
                text:"用户登录统计",
                left:"center"
              },
                xAxis: {
                    type: 'category',
                    data: number.dataDate
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: number.dataNum,
                        type: 'line'
                    }
                ],
                tooltip: { // 鼠标悬浮提示框显示 X和Y 轴数据
                    trigger: 'axis',
                    backgroundColor: 'rgba(32, 33, 36,.7)',
                    borderColor: 'rgba(32, 33, 36,0.20)',
                    borderWidth: 1,
                    textStyle: { // 文字提示样式
                        color: '#fff',
                        fontSize: '12'
                    },
                }
            }
            myChart.setOption(option)
        },
        // 调用接口获取图表数据
        async getNumber () {
            let params = new URLSearchParams();
            // if (!this.inquireList.number01) return this.$message.error('请选择查询条件！')
            
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("ID", window.sessionStorage.getItem("token"))
        
            const { data: res } = await this.$http.get('/User/SelectUserLog', { params })
            this.SysCount=res.SysCount
            this.StrogeCount=res.StrogeCount
            this.UserName=res.UserMessage[0].UserName
            this.Phone=res.UserMessage[0].Phone
            this.Address=res.UserMessage[0].Address
            this.DeptName=res.UserMessage[0].name
            this.UserType=res.UserMessage[0].TypeName
           
            this.init(res)
        }
    }
}
</script>
<style scoped>
.my-label {
  background: var(--el-color-success-light-9);
}
.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.my-content {
  background: var(--el-color-danger-light-9);
}
.my-label {
  background: var(--el-color-success-light-9);
}
.my-content {
  background: var(--el-color-danger-light-9);
}
</style>